import moment from 'moment';

export const spaceName = 'odOrderInvoice';

export interface InvoiceSettings {
  data: any;
  showDetailDrawer: boolean;
  showModal: boolean;
  modalKey: 'extra' | 'refund';

  period: any;
  inputInvoiceId: string;
  inputCustomerName: string;
  inputTableNumber: string;
  pagination: any;
  total: any;

  filter: any;
  editingInvoice: any;
  sumParams: any;

  csvDownloadType: 'xero' | 'transaction' | 'summary';
}

export default {
  showDetailDrawer: false,
  showModal: false,
  period: { start: moment().format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD') },
  inputInvoiceId: '',
  inputCustomerName: '',
  inputTableNumber: '',
  pagination: {
    currentPage: 1,
    pageSize: 50,
  },
  filter: {
    cash: true,
    card: true,
    stripe: true,
  },
  sumParams: {
    sumPaidTotal: 0,
    sumSubTotal: 0,
  },
  csvDownloadType: 'xero',
} as InvoiceSettings;

export const getTableColumns = (props: any) => {
  const {
    helper: { tx },
    invoiceId,
    subtotal,
    paidAmount,
    paidTotal,
    actionButton,
    paidByButton,
    shippingMethod,
    splitByCash,
  } = props;

  // const paidByTypeList = [
  //   { text: 't_cash', value: 'cash' },
  //   { text: 't_card', value: 'card' },
  // ];

  return [
    {
      ...invoiceId,
    },
    {
      title: tx('Orders_Payments.paid_time'),
      dataIndex: 'paidTime',
      key: 'paidTime',
      width: 200,
    },
    {
      ...subtotal,
    },
    { ...splitByCash },
    {
      ...paidByButton,
    },
    {
      ...paidAmount,
    },
    {
      ...paidTotal,
    },
    {
      ...shippingMethod,
    },
    {
      ...actionButton,
    },
  ];
};
